import { FleekError } from './FleekError';

type InvalidPersonalAccessTokenErrorOptions = {
  personalAccessToken: string;
};

export class InvalidPersonalAccessTokenError extends FleekError<InvalidPersonalAccessTokenErrorOptions> {
  public name = 'InvalidPersonalAccessTokenError';

  toString = () => 'Personal access token is invalid.';
}
